import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const TextMessagesSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <Stack
      direction="column"
      justify="between"
      align="start"
      className={"flex-none bg-bg-secondary/50 p-5"}
    >
      <Skeleton className="h-[26px] w-[86px]"></Skeleton>
      <Stack gap={"md"}>
        <Skeleton className="h-2 w-10"></Skeleton>
        <Skeleton className="h-3 w-20"></Skeleton>
      </Stack>
    </Stack>
  </BusinessSettingsSidebarWrapper>
);
